import QuizResult from "../../components/QuizPage/QuizResult"
import Footer from "../../components/common/Footer"
import Header from "../../components/common/Header"
import { useLocation } from "react-router"

const QuizResultPage = () => {
  const location = useLocation()
  return (
    <>
      <Header />
      <QuizResult data={location.state} />
      <Footer />
    </>
  )
}

export default QuizResultPage
